import {Component, Input} from '@angular/core';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {LeadService} from '../../../../services/lead.service';
import {UserType} from '../../../../models/dcp-user-type.model';
import {LeadFormLoginComponent} from '../lead-form-login.component';

@Component({
  selector: 'dcp-lead-form-user-login',
  templateUrl: './lead-form-user-login.component.html',
  styleUrls: ['../lead-form-login.component.scss']
})
export class LeadFormUserLoginComponent extends LeadFormLoginComponent {

  @Input() userType: UserType;

  constructor(public authService: DcpAuthService,
              public leadService: LeadService) {
    super(authService, leadService);
  }
}
